import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const AppPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}', // → blue.500 = #3b82f6
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}',
        },
        formField: {
          background: 'var(--bg-color-input)',
          borderColor: 'var(--border-color-input)',
          color: 'var(--text-color-primary)',
          placeholderColor: 'var(--text-color-disabled)',
        },
        content: {
          background: 'var(--bg-color-card)',
          borderColor: 'var(--border-color-base)',
          color: 'var(--text-color-primary)',
        },
        overlay: {
          select: {
            background: 'var(--bg-color-card)',
            borderColor: 'var(--border-color-base)',
            color: 'var(--text-color-primary)',
          },
          modal: {
            background: 'var(--bg-color-card)',
            borderColor: 'var(--border-color-base)',
            color: 'var(--text-color-primary)',
          },
        },
      },
      dark: {
        primary: {
          color: '{primary.400}', // → blue.400 = #60a5fa (más claro en dark)
          contrastColor: '#ffffff',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
        formField: {
          background: 'var(--bg-color-input)',
          borderColor: 'var(--border-color-input)',
          color: 'var(--text-color-primary)',
          placeholderColor: 'var(--text-color-disabled)',
        },
        content: {
          background: 'var(--bg-color-card)',
          borderColor: 'var(--border-color-base)',
          color: 'var(--text-color-primary)',
        },
        overlay: {
          select: {
            background: 'var(--bg-color-card)',
            borderColor: 'var(--border-color-base)',
            color: 'var(--text-color-primary)',
          },
          modal: {
            background: 'var(--bg-color-card)',
            borderColor: 'var(--border-color-base)',
            color: 'var(--text-color-primary)',
          },
        },
      },
    },
  },
});

export default AppPreset;
